// shared
import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
// store
import useCommonStore from 'store/useCommonStore';
import { PlatformCode } from 'type/common';
// styled
import { IdInner, TableCellWrapper } from './style';
// type
import type { ICell } from './type';
import {
	IconInstagramColored,
	IconNaverBlogColored,
	IconTiktokColored,
	IconYoutubeColored,
} from '@featuring-corp/icons';

const platform_icon = {
	ig: <IconInstagramColored />,
	yt: <IconYoutubeColored />,
	nb: <IconNaverBlogColored />,
	tt: <IconTiktokColored />,
	none: <></>,
};

export interface IProfileCell extends ICell {
	profile_url?: string;
	username: string;
	platform_code?: PlatformCode;
}

const Profile = ({
	_width,
	_margin,
	_padding,
	profile_url,
	username,
	platform_code,
}: IProfileCell) => {
	const { platform } = useCommonStore();

	return (
		<TableCellWrapper _width={_width} flex="start" _margin={_margin} _padding={_padding}>
			<IdInner>
				<CoreSvg _margin="0 16px 0 0">
					{platform_icon[platform_code ?? platform.code ?? 'none']}
				</CoreSvg>
				<CorePictureAvatar
					size="small"
					picture={profile_url}
					color_type="gray"
					text={username}
				/>
			</IdInner>
		</TableCellWrapper>
	);
};

export default Profile;
